import { useState } from 'react';

import { Button, Icon, Input, InputPassword, Label, Loading } from '@olist/united';

import { useAuth } from '@contexts/AuthUserContext';

import * as S from './SignInView.styles';

const logo = '/images/vnda-network.svg';

const SignInView = () => {
  const { authUser, hasError, loading, signIn, submiting } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    await signIn(email, password);
  };

  if (loading || authUser?.uid)
    return (
      <S.Container>
        <Loading />
      </S.Container>
    );

  return (
    <S.Container>
      <S.LogoContainer>
        <S.LogoContentWrapper>
          <S.ImagesWrapper>
            <S.MainLogo src={logo} alt="Logo vnda" />
          </S.ImagesWrapper>
          <S.Subtitle>
            <b>Tecnologia</b> em E-commerce
          </S.Subtitle>
        </S.LogoContentWrapper>
      </S.LogoContainer>

      <S.FormContainer>
        <S.FormWrapper>
          <S.Title>bem-vindos ao nosso portal de oportunidades</S.Title>
          <S.DescriptionText>
            para cadastrar oportunidades, você precisa ser uma agência ativa no
            <b> vnda network</b> e ter recebido o seu acesso
            <small>
              caso seja uma agência ativa e ainda não tenha acesso,entre em contato com
              network@vnda.com.br
            </small>
          </S.DescriptionText>

          {hasError && (
            <S.ErrorContainer>
              <Icon name="alert-circle-outline" color="foundation.errorDark" size={20} /> Tente
              novamente com as credenciais válidas
            </S.ErrorContainer>
          )}

          <form onSubmit={handleSubmit}>
            <Label>
              <b>usuário</b>
              <Input
                name="email"
                placeholder="Informe o email de acesso à conta"
                type="text"
                value={email}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setEmail(event.target.value)
                }
              />
            </Label>
            <Label>
              <b>senha</b>
              <InputPassword
                id="password"
                name="password"
                placeholder="Informe sua senha"
                type="password"
                value={password}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  setPassword(event.target.value)
                }
              />
            </Label>
            <S.SubmitContainer>
              <Button disabled={submiting} variation="alternate" fullWidth type="submit">
                continuar
              </Button>
            </S.SubmitContainer>
          </form>
        </S.FormWrapper>
      </S.FormContainer>
    </S.Container>
  );
};

export { SignInView };
